<span class="sh-icon-label" [title]="tooltip">
    <ng-container *ngIf="iconPosition==='left'; else right">
        <ng-container *ngTemplateOutlet="left"></ng-container>
    </ng-container>
</span>

<ng-template #left>
    <svg sh-icon *ngIf="icon" [name]="icon" [size]="iconSize" aria-hidden="true" class="sh-icon-label__icon" [class.-sh-superscript]="iconSuperscript"></svg>
    {{ label }}
</ng-template>

<ng-template #right>
    {{ label }}
    <svg sh-icon *ngIf="icon" [name]="icon" [size]="iconSize" aria-hidden="true" class="sh-icon-label__icon" [class.-sh-superscript]="iconSuperscript"></svg>
</ng-template>
